import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import AuditOverview from "../../components/dashboard-statistics/audit-overview/AuditOverview";
import AuditResultTable from "./audit-result-table/AuditResultTable";
import styles from "./Audit.module.scss";

export interface AuditFiltersState {
  storeId: string;
  startDate: string;
  endDate: string;
}

const Audit = () => {
  const { t } = useTranslation("translation");
  const today = new Date();
  const defaultStart = new Date(today.getFullYear(), today.getMonth(), 1)
    .toISOString()
    .slice(0, 10);
  const defaultEnd = today.toISOString().slice(0, 10);
  const [storeId, setStoreId] = useState<string>("");
  const [startDate, setStartDate] = useState<string>(defaultStart);
  const [endDate, setEndDate] = useState<string>(defaultEnd);
  const [applied, setApplied] = useState<AuditFiltersState>({
    storeId: "",
    startDate: defaultStart,
    endDate: defaultEnd,
  });

  const appliedFilters = useMemo(() => applied, [applied]);

  const handleApply = () => {
    setApplied({
      storeId,
      startDate,
      endDate,
    });
  };

  const handleReset = () => {
    setStoreId("");
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setApplied({
      storeId: "",
      startDate: defaultStart,
      endDate: defaultEnd,
    });
  };

  return (
    <div className={styles.audit}>
      <TitleUpdater title={t("sidebar.audit") as string} />
      <div className={styles.wrapper}>
        <AuditOverview filters={appliedFilters} />
        <AuditResultTable
          filters={appliedFilters}
          onApply={handleApply}
          onReset={handleReset}
          storeId={storeId}
          startDate={startDate}
          endDate={endDate}
          setStoreId={setStoreId}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </div>
    </div>
  );
};

export default Audit;
